<div class="location-by-radius-autocomplete">
	<!-- radius select -->
	<mat-form-field class="filter-container" appearance="outline">
		<mat-label>Radius</mat-label>
		<mat-select placeholder="Select radius" (selectionChange)="onSelectRadius($event.value)">
			<mat-option *ngFor="let radius of radiusOptions" [value]="radius.value">
				{{ radius.label }}
			</mat-option>
		</mat-select>
	</mat-form-field>

	<!-- location select -->
	<mat-form-field class="filter-container" appearance="outline">
		<mat-label>location</mat-label>
		<input matInput aria-label="location" placeholder="Search locations" (input)="search($event)" [matAutocomplete]="auto" />
		<mat-autocomplete #auto="matAutocomplete">
			<mat-option *ngFor="let address of addresses" [value]="address.place_name" (onSelectionChange)="onSelectLocation(address)">
				{{ address.place_name }}
			</mat-option>
		</mat-autocomplete>
	</mat-form-field>
</div>
